module.exports = __webpack_public_path__ + "static/media/children2.feb84ad2.jpg";